const Service = (type, action) => {
	let parsed = null;

	switch (type) {
		case "GET": {
			parsed = {
				type: "GET",
				url: `/api/user_selection/${action.selectionId}/`,
			};
			break;
		}

		case "CREATE": {
			parsed = { type: "POST", url: "/api/user_selection/" };
			break;
		}

		case "ADD_USER": {
			const payload = {
				users: action.users,
				exclusionList: action.exclusionList,
			};
			parsed = {
				type: "POST",
				url: `/api/user_selection/${action.selectionId}/add/`,
				payload,
			};
			break;
		}

		case "COUNT": {
			const payload = {
				users: action.users,
				exclusionList: action.exclusionList,
			};
			parsed = {
				type: "GET",
				url: `/api/user_selection/${action.selectionId}/count/`,
				payload,
			};
			break;
		}

		case "ADD_GROUP": {
			const payload = {
				groups: action.groups,
				all_users: action.allUsers,
				exclusionList: action.exclusionList,
				filters: action.filters,
			};
			parsed = {
				type: "POST",
				url: `/api/user_selection/${action.selectionId}/add/`,
				payload,
			};
			break;
		}

		case "REMOVE_USER": {
			const payload = { users: action.users };
			parsed = {
				type: "POST",
				url: `/api/user_selection/${action.selectionId}/remove/`,
				payload,
			};
			break;
		}

		default: {
			break;
		}
	}

	return parsed;
};

export default Service;
